let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4EcRr")).then(() => parcelRequire('jS2TN'));